import { useQuery } from '@tanstack/react-query';
import { apiWrapper } from '@/apiWrapper';
import { getEndpoints } from '@/endpoints';
import { isAppointmentInfoQueryEnabled } from './appointmentInfoQuery';

export const getAppointmentInformation = async (
  appointmentId: string,
): Promise<GetAppointmentInfoResponseData> => {
  const url = getEndpoints().getAppointmentInformation.replace(
    '{appointmentId}',
    appointmentId,
  );
  const config = { method: 'GET' };

  return await apiWrapper<GetAppointmentInfoResponseData>(url, config);
};

export const useAppointmentInfoQuery = (appointmentId: string) => {
  return useQuery<GetAppointmentInfoResponseData>({
    queryKey: ['appointmentInformation', appointmentId],
    queryFn: () => getAppointmentInformation(appointmentId),
    enabled: isAppointmentInfoQueryEnabled(appointmentId),
  });
};

export interface GetAppointmentInfoResponseData {
  appointmentId: string;
  appointmentType: 'Phone' | 'In Person';
  confirmationId: string;
  name: string;
  agentUserId: string;
  workTypeId: string;
  schedStartTime: string;
  schedEndTime: string;
  image: string;
  destination: string;
  serviceTerritoryId: string;
  serviceTerritoryName?: string;
  appointmentServiceResourceId: string;
  email: string;
  customerId: string;
  status?: string;
  searchedDestination?: string;
}
